import React from "react";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { DotsVerticalIcon, EyeOffIcon, EyeIcon } from "@heroicons/react/outline";

const RowActionsMenu: React.FC<{
  onHideRow: () => void;
  isHidden?: boolean;
}> = ({ onHideRow, isHidden }) => {
  return (
    <Menu as="div" className="relative inline-block text-left">
      <MenuButton className="flex items-center text-gray-400 hover:text-gray-600 focus:outline-none">
        <DotsVerticalIcon className="h-5 w-5" />
      </MenuButton>

      <MenuItems className="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none">
        <div className="py-1">
          <MenuItem>
            {({ focus }) => (
              <button
                onClick={onHideRow}
                className={`${
                  focus ? "bg-gray-100" : ""
                } group flex w-full items-center px-4 py-2 text-sm text-gray-700`}
              >
                {isHidden ? (
                  <>
                    <EyeIcon className="mr-3 h-4 w-4" />
                    Show row
                  </>
                ) : (
                  <>
                    <EyeOffIcon className="mr-3 h-4 w-4" />
                    Hide row
                  </>
                )}
              </button>
            )}
          </MenuItem>
        </div>
      </MenuItems>
    </Menu>
  );
};

export default RowActionsMenu;
